import { Loader2 } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { AISparkles } from "@/components/ui/ai-sparkles";

interface ThemeAnalysisBlockProps {
  aiSummary: string | null;
  keywordCount: number;
  isRegenerating: boolean;
  onRegenerate: () => void;
}

export function ThemeAnalysisBlock({
  aiSummary,
  keywordCount,
  isRegenerating,
  onRegenerate,
}: ThemeAnalysisBlockProps) {
  if (aiSummary) {
    return (
      <Alert className="gradient-border-ai">
        <AISparkles className="h-4 w-4" />
        <AlertTitle className="font-semibold text-sm">Signal AI Theme Analysis</AlertTitle>
        <AlertDescription>{aiSummary}</AlertDescription>
        <button
          onClick={onRegenerate}
          disabled={isRegenerating}
          className="text-xs text-primary hover:underline disabled:opacity-50 mt-2 block"
        >
          {isRegenerating ? "Regenerating…" : "Re-generate"}
        </button>
      </Alert>
    );
  }

  if (keywordCount > 0) {
    return (
      <Alert className="border-border bg-muted/20">
        <AISparkles className="h-4 w-4" />
        <AlertTitle className="font-semibold text-sm">Signal AI Theme Analysis</AlertTitle>
        <AlertDescription className="flex items-center gap-2 text-muted-foreground mt-1">
          <Loader2 className="h-3.5 w-3.5 animate-spin shrink-0" />
          Generating analysis…
        </AlertDescription>
      </Alert>
    );
  }

  return (
    <Alert className="border-border bg-muted/30">
      <AlertTitle className="text-sm text-muted-foreground">Signal AI Theme Analysis</AlertTitle>
      <AlertDescription className="text-xs text-muted-foreground">
        Add keywords to this theme to generate an AI-powered analysis.
      </AlertDescription>
    </Alert>
  );
}
